import { render, staticRenderFns } from "./ProntuarioExames.vue?vue&type=template&id=6f38470a&"
import script from "./ProntuarioExames.vue?vue&type=script&lang=js&"
export * from "./ProntuarioExames.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioExames.vue?vue&type=style&index=0&id=6f38470a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports